"use client";

import React from "react";

import { useTranslations } from "next-intl";

import { CompletedDate } from "@/components/ui/CompletedDate";
import IconCalendar from "@/icons/ui/forms/calendar.svg";
import { cn } from "@/utils/cn";

interface PlanDetailCompletedDateProps {
  quartal: number;
  year: number;
  className?: string;
}

export const PlanDetailCompletedDate = ({
  quartal,
  year,
  className,
}: PlanDetailCompletedDateProps) => {
  const t = useTranslations();

  return (
    <div
      className={cn(
        "grid grid-cols-[min-content,1fr] gap-x-4 items-center",
        className,
      )}
    >
      <IconCalendar className={"row-span-2 self-baseline mt-1"} />
      <span className="font-medium text-sm text-gray-1100">
        {t("Completion date")}:
      </span>
      <CompletedDate
        className={cn("font-bold")}
        quartal={quartal}
        year={year}
      />
    </div>
  );
};

export default PlanDetailCompletedDate;
